
<!-- <div *ngIf="!addtaxshow" (click)="addtaxshow= true" >
    <a class="font-12 mt-2 text-primary cursor-pointer">
        <div class="my-4">
            <span class="ml-1 mb-0 pt-1 intime-font-12 text-dark-50"> <i class="fa fa-plus-square text-primary mr-2"></i>{{'Show Taxes' | localize}}</span>
        </div>
    </a>
</div> -->
<div class="dropdownmodel my-1 ">
    <div class=" dropdown-menuarrow-right">
        <perfect-scrollbar>
            <div class="kt-align-left padding-top-5 p-2 addTax">
                <div class="font-12 font-400 font-size-h5-lg font-size-text font-weight-bolder intime-open-sans"><span>{{'AddTaxes' | localize}}</span></div>
            </div>
            <div class="OverlayPanel p-1" #op1>
                <div class="border-bottom border-top pt-4 container-fluid px-2 mr-7">
                    <div class="row ">
                        <!--<div class="col-md-1">
                            <div class="form-group mb-0">
                                <label class="width-percent-0"></label>
                            </div>
                        </div>-->
                        <div class="col-3 col-md-3 pr-0">
                            <div class="mb-0">
                                <label class="font-12  mb-0 text-dark-65 intime-open-sans">{{'Rate' | localize}}</label><span class="text-danger text-required" >*</span>
                            </div>
                        </div>
                        <div class="col-4 col-md-4 px-1">
                            <div class="mb-0">
                                <label class="font-12  mb-0 text-dark-65 intime-open-sans ">{{'TaxName' | localize}}</label><span class="text-danger text-required" >*</span>
                            </div>
                        </div>
                        <div class="col-5 col-md-5 px-0">
                            <div class="b-0">
                                <label class="font-12 mb-0 text-dark-65 intime-open-sans">{{'TaxNumber' | localize}}</label>
                            </div>
                        </div>
                        <!--<div class="col-md-1">
                            <div class="form-group mb-0">
                                <label class="width-percent-0"></label>
                            </div>
                        </div>-->
                    </div>

                        <div class="row mt-1 mb-1" *ngFor="let tax of containers; let i = index">

                            <div class="col-3 col-md-3 pr-0">
                                <div class="form-group mb-0">
                                    <div class="input-group-sm">
                                        <input type="number" min="0" class="form-control" (keypress)="onlyNumberKey($event)" name="Rate{{i}}" [(ngModel)]="tax.taxRate"
                                        [ngClass]="{ 'is-invalid':taxFormSubmitted && (tax.taxRate == undefined || tax.taxRate == null) }">
                                    </div>
                                </div>
                                <div *ngIf="taxFormSubmitted && (tax.taxRate == undefined || tax.taxRate == null)" class="invalid-feedback-display">
                                    <div>
                                        <span>{{'EnterTaxRate' | localize}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 px-1">
                                <div class="form-group mb-0">
                                    <div class="input-group-sm">
                                        <input type="text" class="form-control" name="TaxName{{i}}" [(ngModel)]="tax.taxName"
                                        [ngClass]="{ 'is-invalid': taxFormSubmitted && !tax.taxName}">
                                    </div>
                                    <div *ngIf="taxFormSubmitted && !tax.taxName" class="invalid-feedback-display">
                                        <div>
                                            <span>{{'EnterTaxName' | localize}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 col-md-4 px-0">
                                <div class="form-group mb-0">
                                    <div class="input-group-sm">
                                        <input type="number"  class="form-control" name="TaxNumber{{i}}" [(ngModel)]="tax.taxNumber">
                                    </div>
                                </div>
                                <!-- <div *ngIf="taxFormSubmitted && (tax.taxNumber == undefined || tax.taxNumber == null)" class="invalid-feedback-display">
                                    <div>
                                        <span>{{'EnterTaxNumber' | localize}}</span>
                                    </div>
                                </div> -->
                            </div>
                            <div class="col-1 col-md-1 pl-1">
                                <div class="form-group mb-0">
                                    <div class="input-group-sm">
                                        <button type="button" class="btn btn-sm p-0 border-0" (click)="deleteTax(i)"><i class="la la-trash cursor-pointer font-size icon-lg pt-2" style="color: #DB4248;"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    <div class="row">
                        <div class=" col-md-12 pb-3 pt-3 pl-1">
                            <button type="button" class="btn btn-square btn-sm" *ngIf="containers.length < 5" (click)="addTax()" style="color:#0078d4;">
                                <b>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle"
                                        viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                        <path
                                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg> <small class="ml-2 font-12 font-weight-bolder">{{"AddAnotherTax" | localize}}</small>
                                </b>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 d-flex justify-content-end mb-2">
                        <button class="btn btn-square btn-outline-danger btn-sm text-center px-5" type="button" (click)="ClosetaxModel()">
                          {{ "Cancel" | localize }}
                        </button>
                        <button type="button" class="btn btn-square btn-primary btn-sm text-center px-5" (click)="applytaxes()">
                          {{ 'ApplyTaxes' | localize }}
                        </button>
                      </div>
                </div>
            </div>
        </perfect-scrollbar>
    </div>
</div>

